import { collection, getDocs, deleteDoc, query, where } from 'firebase/firestore';
import { db } from '../firebase';

// Service to clear user-specific data from Firebase
export const clearAllUserData = async (userId) => {
  if (!userId) {
    throw new Error('User ID is required to clear data');
  }

  try {
    const results = {
      acceptedEvents: 0,
      pendingEvents: 0,
      emails: 0,
      tldrs: 0
    };

    // Clear accepted events for specific user
    const acceptedEventsRef = collection(db, 'acceptedEvents');
    const acceptedQuery = query(acceptedEventsRef, where('userId', '==', userId));
    const acceptedSnapshot = await getDocs(acceptedQuery);
    
    for (const doc of acceptedSnapshot.docs) {
      await deleteDoc(doc.ref);
      results.acceptedEvents++;
    }

    // Clear pending events for specific user
    const pendingEventsRef = collection(db, 'pendingEvents');
    const pendingQuery = query(pendingEventsRef, where('userId', '==', userId));
    const pendingSnapshot = await getDocs(pendingQuery);
    
    for (const doc of pendingSnapshot.docs) {
      await deleteDoc(doc.ref);
      results.pendingEvents++;
    }

    // Clear emails for specific user
    const emailsRef = collection(db, 'emails');
    const emailsQuery = query(emailsRef, where('userId', '==', userId));
    const emailsSnapshot = await getDocs(emailsQuery);
    
    for (const doc of emailsSnapshot.docs) {
      await deleteDoc(doc.ref);
      results.emails++;
    }

    // Clear TLDRs for specific user
    const tldrsRef = collection(db, 'tldrs');
    const tldrsQuery = query(tldrsRef, where('userId', '==', userId));
    const tldrsSnapshot = await getDocs(tldrsQuery);
    
    for (const doc of tldrsSnapshot.docs) {
      await deleteDoc(doc.ref);
      results.tldrs++;
    }

    return results;
  } catch (error) {
    console.error('Error clearing user data:', error);
    throw error;
  }
};